export async function EntrenamientoCreate(
  entrResp,
  entrFecha,
  entrNumses,
  entrMedio,
  entrHipertenRad,
  entrHiperlidRad,
  entrHiperglucRad,
  entrHistfamRad,
  entrTabaqRad,
  entrEstvidaRad,
  entrObesidRad,
  entrEnfermRad,
  entrEnfermEsp,
  entrDolorpechoRad,
  entrDolorpechoEsp,
  entrNoactpechoRad,
  entrNoactpechoEsp,
  entrMareosRad,
  entrMareosEsp,
  entrProbarticRad,
  entrProbarticEsp,
  entrFarmcardRad,
  entrFarmcardEsp,
  entrRaznoactRad,
  entrRaznoactEsp,
  entrConcl,
  entrTrabactfis,
  entrTrabactfisEsp,
  entrTiempocio,
  entrTiempocioEsp,
  entrTipoejercsem,
  entrTipoejercmes,
  entrTipoejercano,
  entrPercejerc,
  entrEjercnegRad,
  entrEjercnegEsp,
  entrProgactfisRad,
  entrProgactfisEsp,
  entrActmasgust,
  entrProgactfisconseg,
  entrProgactfisdedic,
  entrEjercultsem,
  entrEjercvezsem,
  entrEjercpract,
  entrEjercintens,
  entrEjercpercep,
  entrObs,
  entrEstado,
  tratamientoId,
  pacienteId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-entr-${entrNumses}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-entr-${entrNumses}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      entrResp: entrResp,
      metaFecha: entrFecha,
      metaPaciente: pacienteId,
      entrNumses: entrNumses,
      entrMedio: entrMedio,
      entrHipertenRad: entrHipertenRad,
      entrHiperlidRad: entrHiperlidRad,
      entrHiperglucRad: entrHiperglucRad,
      entrHistfamRad: entrHistfamRad,
      entrTabaqRad: entrTabaqRad,
      entrEstvidaRad: entrEstvidaRad,
      entrObesidRad: entrObesidRad,
      entrEnfermRad: entrEnfermRad,
      entrEnfermEsp: entrEnfermEsp,
      entrDolorpechoRad: entrDolorpechoRad,
      entrDolorpechoEsp: entrDolorpechoEsp,
      entrNoactpechoRad: entrNoactpechoRad,
      entrNoactpechoEsp: entrNoactpechoEsp,
      entrMareosRad: entrMareosRad,
      entrMareosEsp: entrMareosEsp,
      entrProbarticRad: entrProbarticRad,
      entrProbarticEsp: entrProbarticEsp,
      entrFarmcardRad: entrFarmcardRad,
      entrFarmcardEsp: entrFarmcardEsp,
      entrRaznoactRad: entrRaznoactRad,
      entrRaznoactEsp: entrRaznoactEsp,
      entrConcl: entrConcl,
      entrTrabactfis: entrTrabactfis,
      entrTrabactfisEsp: entrTrabactfisEsp,
      entrTiempocio: entrTiempocio,
      entrTiempocioEsp: entrTiempocioEsp,
      entrTipoejercsem: entrTipoejercsem,
      entrTipoejercmes: entrTipoejercmes,
      entrTipoejercano: entrTipoejercano,
      entrPercejerc: entrPercejerc,
      entrEjercnegRad: entrEjercnegRad,
      entrEjercnegEsp: entrEjercnegEsp,
      entrProgactfisRad: entrProgactfisRad,
      entrProgactfisEsp: entrProgactfisEsp,
      entrActmasgust: entrActmasgust,
      entrProgactfisconseg: entrProgactfisconseg,
      entrProgactfisdedic: entrProgactfisdedic,
      entrEjercultsem: entrEjercultsem,
      entrEjercvezsem: entrEjercvezsem,
      entrEjercpract: entrEjercpract,
      entrEjercintens: entrEjercintens,
      entrEjercpercep: entrEjercpercep,
      entrObs: entrObs,
      entrEstado: entrEstado,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/entrenamiento",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
